import {
  DownloadOutlined,
  FilterOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  InputRef,
  Popover,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  TableColumnType,
  Tag,
  Tooltip,
} from "antd";
import React, { FC, Key, useContext, useEffect, useRef, useState } from "react";
import type { ColumnsType } from "antd/es/table";
import "../../../CapsitechAccountsComponents/Pages/SalesAndPurchase/Css/Purchase.css";
import ItemsServices, {
  ItemAdd_Type,
  ItemStatus,
  ItemType,
} from "../../Services/ItemsService";
import AddItems from "./AddItems";
import { useClient } from "../../Context/ClientContext";
import { NavLink, useLocation } from "react-router-dom";
import { useTheme } from "../../Context/ThemeContext";
import "../../Common/Acc_Common.css";
import search from "../../Images/search.svg";
import { Utils } from "../../../Utilities/Utils";
import InvoiceExportService from "../../Services/InvoiceExportDetails";
import {
  FilterDropdownProps,
  TableRowSelection,
} from "antd/es/table/interface";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { notificationContext } from "../../Common/Routing/PageRoute";
import {
  NumberSearchTableEnum,
  NumberSearchTableOption,
  TextSearchTableEnum,
  TextSearchTableOption,
} from "../../Common/SearchTableOptions";
import ItemCategoryService from "../../Services/ItemCategoryService";
import { findUserOnlyOnePremission } from "../Users/Roles/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import CbAddButton from "../../Components/ui/Button/CbAddButton";
import CbDeleteIconButton from "../../Components/ui/IconButton/CbTableDeleteIconButton";
import CbEditIconButton from "../../Components/ui/IconButton/CbTableEditIconButton";
import { tablePageSizeOptions } from "../../Common/ThemeSetting";

const TaxPreferenceOption = [
  {
    label: "Exclusive Tax",
    value: false,
  },
  {
    label: "Inclusive Tax",
    value: true,
  },
];

const ItemTypeOption = [
  {
    label: "Goods",
    value: false,
  },
  {
    label: "Services",
    value: true,
  },
];

export interface IItemListData {
  key: string;
  sno: number;
  id: string;
  name: string;
  number: string;
  // description: string;
  hsnSacCode: string;
  itemType: boolean;
  isTaxable: boolean;
  gstRate: number;
  taxType: boolean;
  // unitPrice: number;
  salesPrice: number;
  purchasePrice: number;
  accountHead: string;
  vat: string;
  ItemStatus: ItemStatus;
}

const ItemTable: FC<{
  itemPage: ItemType;
  trigger?: boolean;
  setTrigger?: any;
  partyId?: string;
  itemAddType?: ItemAdd_Type;
  setItemsListPassToOpeningBalance?: any;
  oldItem?: boolean;
}> = (props) => {
  type DataIndex = keyof IItemListData;
  const { currentClient, companySettings } = useClient();
  const { clientSpecificRole } = useUser();
  // const user = useSelector((state: RootState) => state.data.User);
  // const indianState = useSelector((state: RootState) => state.data.IndianState);
  // const current = useSelector((state: RootState) => state.clientRedus);
  const { openNotification } = useContext(notificationContext);
  const searchInput = useRef<InputRef>(null);
  const searchSelect = useRef<any>(null);
  const [openDropdown, setOpenDropdown] = useState<DataIndex | null>(null);

  const companyGstAndNotGst = [
    ...companySettings?.gsts!,
    {
      name: "Not GST Item",
      id: -1,
      rate: null,
    },
  ];

  // console.log("data", companyGstAndNotGst);

  const { themeData } = useTheme();

  console.log("themeData", themeData);
  const location = useLocation();
  const [openModel, setOpenModel] = useState<any>({
    type: "",
    param: {},
  });
  const [itemsList, setItemsList] = useState<IItemListData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [trigger, setTrigger] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(
    themeData?.tablePageSize ?? 15
  );
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [searchItem, setSearchItem] = useState<string>("");
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  // const [isService, setIsServices] =useState<string>();
  // const [gstRate, setGstRate] = useState<any[]>([]);
  const [width, setWidth] = useState<any>(window.innerWidth);
  const [filter, setfilter] = useState<any>({
    sortCol: "",
    sortDir: "",
  });
  const [exportItemsData, setExportItemsData] = useState<any>([]);
  const [exportType, setExportType] = useState<number>(-1);
  const [type, setType] = useState<ItemType>(props.itemPage);
  const [itemStatus, setItemStatus] = useState<ItemStatus>(ItemStatus.Active);
  const [searchColumns, setSearchColumns] = useState<any>({
    name: "",
    number: "",
    purchasePrice: "",
    salesPrice: "",
    itemType: null,
    hsnSacCode: "",
    isTaxable: null,
    gstRate: null,
  });
  const [searchColumnCount, setSearchColumnCount] = useState<number>(0);
  const [searchColumnsDropDown, setSearchColumnsDropDown] = useState<{
    nameDropEnum: TextSearchTableEnum;
    nameDropPre: TextSearchTableEnum;
    numberDropEnum: TextSearchTableEnum;
    numberDropPre: TextSearchTableEnum;
    purchasePriceDropEnum: NumberSearchTableEnum;
    purchasePriceDropPre: NumberSearchTableEnum;
    salesPriceDropEnum: NumberSearchTableEnum;
    salesPriceDropPre: NumberSearchTableEnum;
    hsnCodeDropEnum: TextSearchTableEnum;
    hsnCodeDropPre: TextSearchTableEnum;
  }>({
    nameDropEnum: TextSearchTableEnum.contains,
    nameDropPre: TextSearchTableEnum.contains,
    numberDropEnum: TextSearchTableEnum.contains,
    numberDropPre: TextSearchTableEnum.contains,
    purchasePriceDropEnum: NumberSearchTableEnum.equalTo,
    purchasePriceDropPre: NumberSearchTableEnum.equalTo,
    salesPriceDropEnum: NumberSearchTableEnum.equalTo,
    salesPriceDropPre: NumberSearchTableEnum.equalTo,
    hsnCodeDropEnum: TextSearchTableEnum.contains,
    hsnCodeDropPre: TextSearchTableEnum.contains,
  });
  const [itemCategoryList, setItemCategoryList] = useState<any[]>([]);
  const [categoryLoading, setCategoryLoading] = useState<boolean>(false);
  const [categoryId, setCategoryId] = useState<string>("");

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  // Get list useEffect
  useEffect(() => {
    // setLoading(true);
    if (currentClient?.id && (exportType === -1 || exportType)) {
      const requestModel = {
        name: searchColumns.name?.trim(),
        nameDropEnum: searchColumnsDropDown.nameDropEnum,
        number: searchColumns.number?.trim(),
        numberDropEnum: searchColumnsDropDown.numberDropEnum,
        purchasePrice: Utils.getIsNaNReturnNull(searchColumns.purchasePrice),
        purchasePriceDropEnum: searchColumnsDropDown.purchasePriceDropEnum,
        salesPrice: Utils.getIsNaNReturnNull(searchColumns.salesPrice),
        salesPriceDropEnum: searchColumnsDropDown.salesPriceDropEnum,
        itemType: searchColumns.itemType,
        hsnCode: searchColumns.hsnSacCode?.trim(),
        hsnCodeDropEnum: searchColumnsDropDown.hsnCodeDropEnum,
        isTaxable: searchColumns.isTaxable,
      };
      getList(
        currentClient?.id,
        exportType >= 1 ? 0 : (page - 1) * pageSize,
        exportType >= 1 ? 0 : pageSize,
        // (page - 1) * pageSize,
        // pageSize,
        filter.sortCol,
        filter.sortDir,
        searchItem,
        undefined,
        type,
        searchColumns.gstRate,
        props?.oldItem,
        itemStatus,
        categoryId,
        searchColumnCount,
        requestModel,
        props?.oldItem ? ItemAdd_Type.Opening : ItemAdd_Type.All
      );
    } else if (currentClient?.id === null) {
      console.error("Invalid client");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.trigger,
    trigger,
    page,
    pageSize,
    searchItem,
    location.pathname,
    filter.sortCol,
    filter.sortDir,
    type,
    exportType,
    searchColumns,
    itemStatus,
    categoryId,
    props.setItemsListPassToOpeningBalance,
  ]);

  // --------- Get List TableData API ---------
  const getList = async (
    clientId: string,
    start: number,
    length: number,
    sortCol?: string,
    sortDir?: string,
    search?: string,
    status?: any,
    type?: ItemType,
    gstRate?: number[],
    itemInventory?: boolean,
    itemStatus?: ItemStatus,
    categoryId?: string,
    searchColumnCount?: number,
    requestModel?: any,
    itemAddType: ItemAdd_Type = ItemAdd_Type.All
  ) => {
    // debugger;
    if (exportType < 1) {
      setLoading(true);
    }
    await ItemsServices.getListItems(
      clientId,
      start,
      length,
      sortCol,
      sortDir,
      search,
      status,
      type,
      gstRate,
      itemInventory,
      itemStatus,
      categoryId,
      searchColumnCount,
      requestModel,
      itemAddType
    )
      .then((res: any) => {
        if (res.items.length > 0) {
          let ItemsData = res?.items?.map((v: any, i: any) => {
            return {
              key: i,
              sno: v?.sno,
              id: v?.id,
              name: v?.name,
              number: v?.number,
              hsnSacCode: v?.hsnSacCode,
              itemType: v?.isService,
              taxType: v?.isTaxable,
              salesPrice: v?.sPrice,
              purchasePrice: v?.pPrice,
              ItemStatus: v?.itemStatus,
              openingStock: v?.openingStock,
              trackingType: v?.trackingType,
              gstRate: v?.taxRate,
              batchItems: v?.batchItem,
              serialItems: v?.serialItem,
            };
          });
          itemAddType === ItemAdd_Type.Opening &&
            props?.setItemsListPassToOpeningBalance(ItemsData);
          if (exportType >= 1) {
            setExportItemsData(ItemsData);
            if (exportType === 1) {
              exportCsv(ItemsData);
            } else if (exportType === 2) {
              exportPDF(ItemsData);
            } else if (exportType === 3) {
              exportExcel(ItemsData);
            }
          } else {
            setItemsList(ItemsData);
            setTotalRecords(res?.totalRecords);
          }
          setTotalRecords(res?.totalRecords);
          // console.log("table,,,,,,,,,,,", props.trigger);
        } else if (res.items.length === 0) {
          setItemsList([]);
          setTotalRecords(res?.totalRecords);
        }
        setLoading(false);
      })
      .catch((ex: any) => {
        console.error(ex.message);
        setLoading(false);
        setItemsList([]);
      });
  };

  // get api Item Category
  useEffect(() => {
    setCategoryLoading(true);
    const getCategoryNameList = async () => {
      await ItemCategoryService.getCategoryList(currentClient?.id, 0, 15)
        .then((res: any) => {
          if (res?.result?.items?.length > 0) {
            setItemCategoryList(res?.result?.items);
            setCategoryLoading(false);
          } else {
            setCategoryLoading(false);
            setItemCategoryList([]);
          }
        })
        .catch((err) => {
          setCategoryLoading(false);

          setItemCategoryList([]);
          console.error(err?.message);
        });
    };
    getCategoryNameList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  useEffect(() => {
    const handleKeyDown = (e: any) => {
      console.log("useEffect", e.shiftKey);

      if (e.shiftKey && e.key === "I") {
        setOpenModel({
          type: "addItem",
          param: { open: true },
        });
      }
      if (e.altKey) {
        if (e.shiftKey && e.key.toLowerCase() === "c") {
          setOpenModel({ type: "", param: "" });
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Table Search Inide

  // const handleSearch = (
  //   selectedKeys: string[] | any,
  //   confirm: any,
  //   dataIndex: DataIndex
  // ) => {
  //   console.log("handleSearch", dataIndex, selectedKeys, searchColumns);

  //   let prevValue = searchColumns[dataIndex];
  //   let newValue = selectedKeys;

  //   console.log("newValue", prevValue, newValue);
  //   if (newValue?.length < 0) {
  //     confirm();
  //     setOpenDropdown(null);
  //     return;
  //   }

  //   let newSearchColumns = { ...searchColumns };
  //   console.log("newSearchColumns", newSearchColumns);

  //   switch (dataIndex) {
  //     case "name":
  //     case "number":
  //     case "purchasePrice":
  //     case "salesPrice":
  //     case "hsnSacCode":
  //       newSearchColumns[dataIndex] = selectedKeys[0];
  //       break;
  //     case "itemType":
  //     case "isTaxable":
  //     case "gstRate":
  //       newSearchColumns[dataIndex] = selectedKeys;
  //       break;
  //   }

  //   if (!prevValue && newValue?.length > 0) {
  //     setSearchColumnCount((prev) => prev + 1);
  //   }

  //   setSearchColumns(newSearchColumns);
  //   // console.log(searchColumnCount, "count", prevValue, newValue, selectedKeys);
  //   confirm();
  //   setOpenDropdown(null); // Close the dropdown
  // };

  const checkFilterType = (dataIndex: DataIndex) => {
    // debugger;
    let isChangefilterType = false;
    switch (dataIndex) {
      case "name":
        isChangefilterType =
          searchColumnsDropDown.nameDropEnum ===
          searchColumnsDropDown.nameDropPre;
        break;
      case "number":
        isChangefilterType =
          searchColumnsDropDown.numberDropEnum ===
          searchColumnsDropDown.numberDropPre;
        break;
      case "purchasePrice":
        isChangefilterType =
          searchColumnsDropDown.purchasePriceDropEnum ===
          searchColumnsDropDown.purchasePriceDropPre;
        break;
      case "salesPrice":
        isChangefilterType =
          searchColumnsDropDown.salesPriceDropEnum ===
          searchColumnsDropDown.salesPriceDropPre;
        break;
      case "hsnSacCode":
        isChangefilterType =
          searchColumnsDropDown.hsnCodeDropEnum ===
          searchColumnsDropDown.hsnCodeDropPre;
        break;
    }
    return isChangefilterType;
  };

  const handleSearch = (
    selectedKeys: string[] | any,
    confirm: any,
    dataIndex: DataIndex
  ) => {
    // console.log(
    //   "handleSearch",
    //   "dataIndex",
    //   dataIndex,
    //   "selectedKeys",
    //   selectedKeys,
    //   "searchColumns",
    //   searchColumns
    // );

    let prevValue = searchColumns[dataIndex];
    let newValue = selectedKeys;

    // text/number inputs -> pick first value and trim
    if (
      dataIndex === "name" ||
      dataIndex === "number" ||
      dataIndex === "purchasePrice" ||
      dataIndex === "salesPrice" ||
      dataIndex === "hsnSacCode"
    ) {
      newValue =
        selectedKeys && selectedKeys[0] ? String(selectedKeys[0]).trim() : "";
    }

    // normalize for multi-select fields to arrays
    if (
      dataIndex === "itemType" ||
      dataIndex === "isTaxable" ||
      dataIndex === "gstRate"
    ) {
      newValue = Array.isArray(selectedKeys) ? selectedKeys : [];
      const prevArr = Array.isArray(prevValue) ? prevValue : [];
      const sameLength = prevArr.length === newValue.length;
      const sameItems =
        sameLength && prevArr.every((v, i) => v === newValue[i]);

      // empty selection + no previous -> do nothing
      if (!newValue.length && !prevArr.length) {
        confirm();
        setOpenDropdown(null);
        return;
      }

      // selection unchanged -> do nothing
      if (sameItems) {
        confirm();
        setOpenDropdown(null);
        return;
      }
    } else {
      // text/number: empty + no previous -> do nothing
      if (newValue === "" && (!prevValue || String(prevValue).trim() === "")) {
        confirm();
        setOpenDropdown(null);
        return;
      }
      // debugger;
      // text/number: unchanged value -> do nothing
      if (
        typeof prevValue === "string" &&
        newValue === String(prevValue).trim() &&
        checkFilterType(dataIndex)
      ) {
        confirm();
        setOpenDropdown(null);
        return;
      }
    }

    setSearchColumnsDropDown((prevState) => {
      const newState = { ...prevState };
      switch (dataIndex) {
        case "name":
          newState.nameDropPre = prevState.nameDropEnum;
          break;
        case "number":
          newState.numberDropPre = prevState.numberDropEnum;
          break;
        case "purchasePrice":
          newState.purchasePriceDropPre = prevState.purchasePriceDropEnum;
          break;
        case "salesPrice":
          newState.salesPriceDropPre = prevState.salesPriceDropEnum;
          break;
        case "hsnSacCode":
          newState.hsnCodeDropPre = prevState.hsnCodeDropEnum;
          break;
      }
      return newState;
    });

    let newSearchColumns = { ...searchColumns };
    console.log("newSearchColumns", newSearchColumns);

    switch (dataIndex) {
      case "name":
      case "number":
      case "purchasePrice":
      case "salesPrice":
      case "hsnSacCode":
        newSearchColumns[dataIndex] = newValue || "";
        break;
      case "itemType":
      case "isTaxable":
      case "gstRate":
        newSearchColumns[dataIndex] = newValue.length ? newValue : null;
        break;
    }

    // // set or unset searchColumnCount based on previous and new values
    const wasEmpty =
      !prevValue ||
      (Array.isArray(prevValue)
        ? prevValue.length === 0
        : String(prevValue).trim() === "");
    const isNowPopulated =
      (Array.isArray(newValue) && newValue.length > 0) ||
      (!Array.isArray(newValue) && newValue !== "");

    // Case 1: A new filter was added (went from empty to populated)
    if (wasEmpty && isNowPopulated) {
      setSearchColumnCount((prev) => prev + 1);
    }
    // Case 2: A filter was cleared (went from populated to empty)
    else if (!wasEmpty && !isNowPopulated) {
      setSearchColumnCount((prev) => prev - 1);
    }

    // Otherwise, the value was just modified, so the count doesn't change.
    setSearchColumns(newSearchColumns);
    confirm();
    setOpenDropdown(null); // Close the dropdown
  };

  const handleDropdownText = (
    dataIndex: DataIndex,
    valDropDown: TextSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "name":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          nameDropEnum: valDropDown,
          nameDropPre: searchColumnsDropDown.nameDropEnum,
        });
        break;
      case "number":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          numberDropEnum: valDropDown,
          numberDropPre: searchColumnsDropDown.numberDropEnum,
        });
        break;
      case "hsnSacCode":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          hsnCodeDropEnum: valDropDown,
          hsnCodeDropPre: searchColumnsDropDown.hsnCodeDropEnum,
        });
        break;
    }
  };

  const handleDropdownNumber = (
    dataIndex: DataIndex,
    valDropDown: NumberSearchTableEnum
  ) => {
    switch (dataIndex) {
      case "purchasePrice":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          purchasePriceDropEnum: valDropDown,
          purchasePriceDropPre: searchColumnsDropDown.purchasePriceDropEnum,
        });
        break;
      case "salesPrice":
        setSearchColumnsDropDown({
          ...searchColumnsDropDown,
          salesPriceDropEnum: valDropDown,
          salesPriceDropPre: searchColumnsDropDown.salesPriceDropEnum,
        });
        break;
    }
  };

  const handleReset = (
    clearFilters: () => void,
    confirm: FilterDropdownProps["confirm"],
    dataIndex: DataIndex
  ) => {
    clearFilters();
    confirm();

    let prevValue = searchColumns[dataIndex];

    // console.log("newValue111", prevValue, dataIndex);

    if (prevValue) {
      setSearchColumnCount((prev) => prev - 1);

      setSearchColumns((prev: any) => {
        const newSearchColumns = { ...prev };
        delete newSearchColumns[dataIndex];
        return newSearchColumns;
      });
    }
  };

  // const handleReset = (
  //   clearFilters: () => void,
  //   confirm: FilterDropdownProps["confirm"],
  //   dataIndex: DataIndex
  // ) => {
  //   clearFilters();
  //   confirm();
  //   console.log("dataIndex", dataIndex, searchColumns);

  //   switch (dataIndex) {
  //     case "name":
  //       if (searchColumns.name) {
  //         setSearchColumns({
  //           ...searchColumns,
  //           name: "",
  //         });
  //       }
  //       break;
  //     case "number":
  //       if (searchColumns.number) {
  //         setSearchColumns({ ...searchColumns, number: "" });
  //       }
  //       break;
  //     case "purchasePrice":
  //       if (searchColumns.purchasePrice) {
  //         setSearchColumns({ ...searchColumns, purchasePrice: "" });
  //       }
  //       break;
  //     case "salesPrice":
  //       if (searchColumns.salesPrice) {
  //         setSearchColumns({ ...searchColumns, salesPrice: "" });
  //       }
  //       break;
  //     case "itemType":
  //       if (searchColumns.itemType) {
  //         setSearchColumns({ ...searchColumns, itemType: null });
  //       }
  //       break;
  //     case "hsnSacCode":
  //       if (searchColumns.hsnSacCode) {
  //         setSearchColumns({ ...searchColumns, hsnSacCode: "" });
  //       }
  //       break;
  //     case "isTaxable":
  //       if (searchColumns.isTaxable) {
  //         setSearchColumns({ ...searchColumns, isTaxable: null });
  //       }
  //       break;
  //     case "gstRate":
  //       if (searchColumns.gstRate?.length > 0) {
  //         setSearchColumns({ ...searchColumns, gstRate: [] });
  //       }
  //       break;
  //   }
  // };

  const getColumnSearchProps = (
    dataIndex: DataIndex,
    isNumber: boolean,
    searchPlaceHolder?: string
  ): TableColumnType<IItemListData> => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        {dataIndex === "gstRate" ? (
          <Checkbox.Group
            options={companyGstAndNotGst?.map((gst: any) => ({
              key: gst.name,
              value: gst.id,
              title: gst.rate,
              label: gst.name,
            }))}
            style={{
              marginBottom: 8,
              display: "flex",
              flexDirection: "column",
              gap: "6px",
            }}
            // value={searchColumns.gstRate}
            value={selectedKeys}
            onChange={(e: any) => {
              setSelectedKeys(e ? [...e] : []);
            }}
          />
        ) : dataIndex === "isTaxable" ? (
          <Checkbox.Group
            style={{ marginBottom: 8, display: "block", width: "200px" }}
            onChange={(e: any) => {
              setSelectedKeys(e ? [...e] : []);
            }}
            value={selectedKeys}
            options={TaxPreferenceOption?.map((x: any) => ({
              value: x.value,
              label: x.label,
            }))}
          />
        ) : dataIndex === "itemType" ? (
          <div style={{ marginBottom: 8, display: "block", width: "200px" }}>
            <Checkbox.Group
              style={{ marginBottom: 8, display: "block", width: "140px" }}
              onChange={(e: any) => {
                setSelectedKeys(e ? [...e] : []);
              }}
              value={selectedKeys}
              options={ItemTypeOption?.map((x: any) => ({
                value: x.value,
                label: x.label,
              }))}
            />
          </div>
        ) : (
          <>
            {isNumber ? (
              <Select
                defaultValue={NumberSearchTableEnum.equalTo}
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginBottom: "8px",
                }}
                onChange={(val: NumberSearchTableEnum) => {
                  setExportItemsData([]);
                  handleDropdownNumber(dataIndex, val);

                  // setNumberTypeSearchColumn(val);
                  // setType(1);
                }}
                options={NumberSearchTableOption?.map((x: any) => ({
                  value: x.value,
                  label: x.label,
                }))}
              />
            ) : (
              <Select
                defaultValue={TextSearchTableEnum.contains}
                style={{
                  width: "100%",
                  maxWidth: "200px",
                  marginBottom: "8px",
                }}
                onChange={(val: TextSearchTableEnum) => {
                  setExportItemsData([]);
                  handleDropdownText(dataIndex, val);
                  // setTextTypeSearchColumn(val);
                  // setType(1);
                }}
                options={TextSearchTableOption?.map((x: any) => ({
                  value: x.value,
                  label: x.label,
                }))}
              />
            )}
            <Input
              ref={searchInput}
              placeholder={`Search.. ${searchPlaceHolder}`}
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() =>
                handleSearch(selectedKeys as string[], confirm, dataIndex)
              }
              onKeyPress={(e: any) => {
                if (
                  dataIndex === "purchasePrice" ||
                  dataIndex === "salesPrice"
                ) {
                  if (!/\d|[.,]/.test(e.key)) e.preventDefault();
                  // if (!/\d|\./.test(e.key)) e.preventDefault();
                  if (e.key === "." && e.target.value.includes("."))
                    e.preventDefault();
                }
              }}
              style={{ marginBottom: 8, display: "block", width: "200px" }}
            />
          </>
        )}
        <Space>
          <Button
            type="primary"
            onClick={() =>
              handleSearch(selectedKeys as string[], confirm, dataIndex)
            }
            // icon={<SearchOutlined />}

            size="small"
            style={{ width: 95 }}
          >
            Search
          </Button>
          <Button
            onClick={() => {
              clearFilters && handleReset(clearFilters, confirm, dataIndex);
            }}
            size="small"
            style={{ width: 95 }}
          >
            Clear
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered: boolean) =>
      searchPlaceHolder ? (
        <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ) : (
        <FilterOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
      ),
    filterDropdownOpen: openDropdown === dataIndex,
    filterDropdownProps: {
      placement: "bottomLeft",
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setOpenDropdown(dataIndex);
        setTimeout(() => {
          if (dataIndex === "gstRate") {
            searchSelect.current?.focus(); // Use focus for Select component
          } else {
            searchInput.current?.select(); // Use select for Input component
          }
        }, 100);
      } else {
        setOpenDropdown(null);
      }
    },
  });

  const permissionEdit = findUserOnlyOnePremission(
    "Master.Item.Edit",
    clientSpecificRole(),
    currentClient?.id!
  );

  const permissionDelete = findUserOnlyOnePremission(
    "Master.Item.Delete",
    clientSpecificRole(),
    currentClient?.id!
  );

  // --------- Table Columns  ---------
  const columns: ColumnsType<IItemListData> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.sno}
        </Skeleton>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "Name",
      sorter: true,
      width: width <= 1440 ? "13%" : "18%",
      filteredValue: searchColumns.name ? [searchColumns.name] : null,
      onFilter: (value: any, record) => true,
      render: (_, record) =>
        type === ItemType.SalesItems ? (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            {record?.ItemStatus === ItemStatus.Active ? (
              <NavLink
                to={`/billing/clients/${currentClient?.id}/item/items/inventory`}
                state={{
                  id: record.id,
                  type: type,
                  itemType: record.itemType
                    ? "AllItemServices"
                    : "AllItemGoods",
                }}
              >
                {record?.name}
              </NavLink>
            ) : (
              <>{record?.name}</>
            )}
          </Skeleton>
        ) : (
          <Skeleton
            active
            loading={loading}
            paragraph={{ rows: 1 }}
            title={false}
          >
            {record?.ItemStatus === ItemStatus.Active ? (
              <NavLink
                to={`/billing/clients/${currentClient?.id}/item/items/inventory`}
                state={{
                  id: record.id,
                  type: type,
                  itemType: record.itemType
                    ? "AllItemServices"
                    : "AllItemGoods",
                }}
              >
                {record?.name}
              </NavLink>
            ) : (
              <>{record?.name}</>
            )}
          </Skeleton>
        ),
      ...getColumnSearchProps("name", false, "Name"),
    },
    {
      title: "Code",
      dataIndex: "number",
      key: "Number",
      width: "7%",
      sorter: true,
      defaultSortOrder: "descend",
      filteredValue: searchColumns.number ? [searchColumns.number] : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.number}
        </Skeleton>
      ),
      ...getColumnSearchProps("number", false, "Code"),
    },
    {
      title: "Pur. Price",
      dataIndex: "unitPrice",
      key: "pPrice",
      sorter: true,
      filteredValue: searchColumns.purchasePrice
        ? [searchColumns.purchasePrice]
        : null,
      width: width <= 1440 ? "13%" : "9%",
      align: "right",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {record?.purchasePrice || record?.purchasePrice === 0
            ? Utils.getFormattedNumber(record?.purchasePrice)
            : "-"}
        </Skeleton>
      ),
      ...getColumnSearchProps("purchasePrice", true, "Purchase Price"),
    },
    {
      title: "Sal. Price",
      dataIndex: "unitPrice",
      key: "sPrice",
      filteredValue: searchColumns.salesPrice
        ? [searchColumns.salesPrice]
        : null,
      sorter: true,
      width: width <= 1440 ? "13%" : "9%",
      align: "right",
      render: (_: any, record: any) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{
            rows: 1,
            style: { display: "flex", justifyContent: "end" },
          }}
          title={false}
        >
          {record?.salesPrice || record?.salesPrice === 0
            ? Utils.getFormattedNumber(record?.salesPrice)
            : "-"}
        </Skeleton>
      ),
      ...getColumnSearchProps("salesPrice", true, "Sales Price"),
    },
    {
      title: "Item Type",
      dataIndex: "itemType",
      key: "IsService",
      width: "10%",
      filteredValue:
        searchColumns.itemType || searchColumns.itemType === false
          ? searchColumns.itemType
          : null,
      sorter: true,
      render: (_, record) => {
        if (record?.itemType)
          return (
            <Skeleton
              active
              loading={loading}
              paragraph={{ rows: 1 }}
              title={false}
            >
              <Tag
                color="geekblue"
                style={{
                  textAlign: "center",
                  width: 52,
                }}
              >
                Service
              </Tag>
            </Skeleton>
          );
        else
          return (
            <Skeleton
              active
              loading={loading}
              paragraph={{ rows: 1 }}
              title={false}
            >
              <Tag
                color="green"
                style={{
                  textAlign: "center",
                  width: 52,
                }}
              >
                Goods
              </Tag>
            </Skeleton>
          );
      },
      ...getColumnSearchProps("itemType", false),
    },
    {
      title: "HSN/SAC Code",
      dataIndex: "hsnSacCode",
      key: "HsnSacCode",
      width: "14%",
      sorter: true,
      filteredValue: searchColumns.hsnSacCode
        ? [searchColumns.hsnSacCode]
        : null,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.hsnSacCode}
          {/* SACCode */}
        </Skeleton>
      ),
      ...getColumnSearchProps("hsnSacCode", false, "HSN / SAC Code"),
    },
    {
      title: "Tax Preference",
      dataIndex: "isTaxable",
      key: "IsTaxable",
      filteredValue:
        searchColumns.isTaxable || searchColumns.isTaxable === false
          ? searchColumns.isTaxable
          : null,
      width: width <= 1440 ? "12%" : "10%",
      sorter: true,
      render: (_, record) => {
        if (record?.taxType === true)
          return (
            <Skeleton
              active
              loading={loading}
              paragraph={{ rows: 1 }}
              title={false}
            >
              <Tag
                color="cyan"
                style={{
                  textAlign: "center",
                  width: 85,
                }}
              >
                Inclusive Tax
              </Tag>
            </Skeleton>
          );
        else
          return (
            <Skeleton
              active
              loading={loading}
              paragraph={{ rows: 1 }}
              title={false}
            >
              <Tag
                // bordered={false}
                color="purple"
                style={{
                  textAlign: "center",
                  width: 85,
                }}
              >
                Exclusive Tax
              </Tag>
            </Skeleton>
          );
      },
      ...getColumnSearchProps("isTaxable", false),
    },
    {
      title: "GST",
      dataIndex: "gstRate",
      key: "Rate",
      width: "8%",
      filteredValue: searchColumns.gstRate ? searchColumns.gstRate : null,
      sorter: true,
      // filters: [
      //   {
      //     text: "5%",
      //     value: 5,
      //   },
      //   {
      //     text: "3%",
      //     value: 3,
      //   },
      // ],
      onFilter: (value: any, record) => true,
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          {record?.gstRate}
        </Skeleton>
      ),
      ...getColumnSearchProps("gstRate", false),

      // filtered: true,
    },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (_, record) => (
        <Skeleton
          active
          loading={loading}
          paragraph={{ rows: 1 }}
          title={false}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              {record.ItemStatus !== ItemStatus.Draft && (
                <Tooltip
                  title={
                    record?.ItemStatus === ItemStatus.Active
                      ? "In-Active"
                      : "Active"
                  }
                  placement="top"
                  color="#3D4998"
                >
                  <Checkbox
                    checked={record?.ItemStatus !== ItemStatus.Inactive}
                    title="Delete"
                    onChange={(e: any) => {
                      console.log(e.target.checked, record);
                      setOpenModel({
                        type: "isActive",
                        param: {
                          name: record.name,
                          id: record.id,
                          itemStatus: record?.ItemStatus,
                        },
                      });
                      // setSelectChange(record?.isActive ? "In-Active" : "Active");
                    }}
                  />
                </Tooltip>
              )}
            </div>
            <div>
              {(record.ItemStatus === ItemStatus.Draft ||
                record.ItemStatus === ItemStatus.Active) &&
              permissionEdit ? (
                // <Tooltip title="Edit" placement="top" color="#3D4998">
                <CbEditIconButton
                  onClick={async () => {
                    setOpenModel({
                      type: "addItem",
                      param: {
                        open: true,
                        id: record.id,
                      },
                    });
                  }}
                />
              ) : (
                /* <EditOutlined
                    // className="ca-edit-btn"
                    style={{ color: "#444653" }}
                    onClick={async () => {
                      setOpenModel({
                        type: "addItem",
                        param: {
                          open: true,
                          id: record.id,
                        },
                      });
                    }}
                  /> */
                // </Tooltip>
                <></>
              )}
            </div>
            {permissionDelete && (
              <div>
                <Tooltip title="Delete" placement="top" color="red">
                  <CbDeleteIconButton
                    onClick={() => {
                      setOpenModel({
                        type: "deleteItem",
                        param: {
                          name: record?.name,
                          id: record?.id,
                        },
                      });
                    }}
                  />
                  {/* <DeleteTwoTone
                    className="ca-delete-btn cursor"
                    twoToneColor="#ff879d"
                    onClick={() => {
                      setOpenModel({
                        type: "deleteItem",
                        param: {
                          name: record?.name,
                          id: record?.id,
                        },
                      });
                    }}
                  /> */}
                </Tooltip>
              </div>
            )}
          </div>
        </Skeleton>
      ),
    },
  ];

  //----- Table Ascending & Desending Order -----
  const tableSort = (pagination?: any, sort?: any, filter?: any) => {
    setfilter({
      sortCol: filter.column !== undefined ? filter.columnKey : "number",
      sortDir:
        filter.column !== undefined
          ? filter.order === "descend"
            ? "desc"
            : "asc"
          : "desc",
    });
    console.log("sort1111111111111", sort?.TaxRate?.Rate, sort);
  };

  // Table Download
  const onSelectChange = (newSelectedRowKeys: Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection: TableRowSelection<any> = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  // Get the selected row data
  const selectedRows = itemsList.filter((item) =>
    selectedRowKeys.includes(item.key)
  );

  let path = "Items List";

  const generateFooterRow = (columns: string[]) => {
    return columns.map((col) => "");
  };

  const columnsA = [
    "S.No.",
    "Name",
    "Code",
    "Pur. Price",
    "Sales Price",
    "Item Type",
    "HSN/SAC Code",
    "Tax Preference",
    "GST",
  ];

  const fieldMapping = {
    "S.No.": (item: any) => item?.sno,
    Name: (item: any) => item?.name,
    Code: (item: any) => item?.number,
    "Pur. Price": (item: any) =>
      item?.purchasePrice != null
        ? Utils.getFormattedNumber(item?.purchasePrice)
        : "-",
    "Sales Price": (item: any) =>
      item?.salesPrice != null
        ? Utils.getFormattedNumber(item?.salesPrice)
        : "-",
    "Item Type": (item: any) => (item?.itemType ? "Service" : "Goods"),
    "HSN/SAC Code": (item: any) => item?.hsnSacCode ?? item?.SACCode,
    "Tax Preference": (item: any) =>
      item?.taxType === true ? "Inclusive Tax" : "Exclusive Tax",
    GST: (item: any) => item?.gstRate,
  };

  const exportCsv = (invExportDataa: any[]) => {
    const exportData =
      selectedRowKeys.length > 0 ? selectedRows : invExportDataa;
    InvoiceExportService.generateCSV(
      exportData,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      "",
      path,
      currentClient?.businessName
    );
    setExportType(0);
  };

  const exportPDF = (invExportDataa: any[]) => {
    const exportData =
      selectedRowKeys.length > 0 ? selectedRows : invExportDataa;
    // InvoiceExportService.generatePDF(
    //   exportData,
    //   currentClient?.businessName,
    //   columnsA,
    //   fieldMapping,
    //   generateFooterRow,
    //   "",
    //   path
    // );
    InvoiceExportService.AutoDownloadPDF(
      exportData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const exportExcel = async (invExportDataa: any[]) => {
    const rowData = selectedRowKeys.length > 0 ? selectedRows : invExportDataa;
    await InvoiceExportService.generateExcel(
      rowData,
      currentClient?.businessName,
      columnsA,
      fieldMapping,
      generateFooterRow,
      "",
      path
    );
    setExportType(0);
  };

  const content = (
    <Space direction="vertical">
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="CSV"
          onClick={() => {
            if (exportItemsData.length > 0) {
              exportCsv(exportItemsData);
            } else {
              setExportType(1);
            }
          }}
          icon={<DownloadOutlined />}
        >
          CSV
        </Button>
      </div>

      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="PDF"
          onClick={() => {
            if (exportItemsData.length > 0) {
              exportPDF(exportItemsData);
            } else {
              setExportType(2);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          PDF
        </Button>
      </div>
      <div>
        <Button
          style={{ width: "80px" }}
          size="small"
          title="XLSX"
          onClick={() => {
            if (exportItemsData.length > 0) {
              exportExcel(exportItemsData);
            } else {
              setExportType(3);
              // setApiCallExports(true);
            }
          }}
          icon={<DownloadOutlined />}
        >
          XLSX
        </Button>
      </div>
    </Space>
  );

  return (
    <Card
      size="small"
      className="TableCard"
      style={{
        // marginTop: "6px",
        // padding: "48px 0px 0px 0px",
        marginTop: props?.oldItem ? 5 : 35,
        boxShadow: "0px 0px 10px 0px #96A1C84D",
      }}
    >
      {/* {props.trigger === true || (
        <> */}
      {/* <Affix offsetTop={130}> */}
      {!props?.oldItem && (
        <Row
          justify="space-between"
          style={{
            // paddingTop: props?.partyId ? "10px" : "0px"
            // marginTop: 10,
            padding: "0px 0px 3px 0px",
          }}
          // style={{ position: "sticky",zIndex:1, top: 0, padding: "5px" }}
        >
          <Col>
            <Space>
              {findUserOnlyOnePremission(
                "Master.Item.Add",
                clientSpecificRole(),
                currentClient?.id!
              ) && (
                // <Button
                //   type="primary"
                //   icon={<PlusOutlined />}
                //   onClick={() => {
                //     setOpenModel({
                //       type: "addItem",
                //       param: { open: true },
                //     });
                //   }}
                // >
                //   Item
                // </Button>
                <CbAddButton
                  name="Item"
                  onClick={() => {
                    setOpenModel({
                      type: "addItem",
                      param: { open: true },
                    });
                  }}
                />
              )}
              {/* <Button
                  style={{
                    marginLeft: "10px",
                  }}
                  icon={<ArrowDownOutlined />}
                >
                  Export
                </Button> */}
              {itemsList?.length === 0 ? (
                <>
                  {/* <CbExportButton disabled /> */}
                  <Button
                    type="default"
                    icon={<DownloadOutlined />}
                    // onClick={() => exportCsv()}
                    disabled
                  >
                    Export
                  </Button>
                </>
              ) : (
                <>
                  <Popover
                    content={content}
                    placement="rightTop"
                    trigger="hover"
                  >
                    {/* <CbExportButton /> */}

                    <Button
                      type="default"
                      icon={<DownloadOutlined />}
                      // onClick={() => exportCsv()}
                    >
                      Export
                    </Button>
                  </Popover>
                </>
              )}
            </Space>
          </Col>

          <Col
            style={{
              marginTop: width <= 768 ? 15 : "",
            }}
          >
            <Row gutter={width <= 768 ? 98 : 8}>
              <Col>
                <Input
                  allowClear
                  style={{ width: "200px", border: "1px solid #f1f3ff" }}
                  placeholder="Search.."
                  onChange={(e: any) => {
                    setLoading(true);
                    setExportItemsData([]);
                    if (!e.cancelable) {
                      //console.log("typeing user............");
                      const searchItem = setTimeout(() => {
                        setPage(1);
                        setSearchItem(e.target.value);
                      }, 1000);
                      return () => clearTimeout(searchItem);
                    } else {
                      // console.log("Click cancle............");
                      setSearchItem(e.target.value);
                    }
                  }}
                  suffix={
                    loading || searchItem ? (
                      ""
                    ) : (
                      <img alt="Search.." src={search} />
                    )
                  }
                />
              </Col>
              {companySettings?.setting?.item?.maintainCategory && (
                <Col>
                  <Select
                    style={{ minWidth: "158px" }}
                    allowClear
                    placeholder="Category.."
                    loading={categoryLoading}
                    onChange={(e: any) => {
                      setExportItemsData([]);
                      setCategoryId(e);
                      setPage(1);
                    }}
                    options={itemCategoryList?.map((x: any) => ({
                      value: x?.id,
                      label: x?.categoryName,
                    }))}
                    // dropdownRender={(itemCategoryList) => (
                    //   <>
                    //     {itemCategoryList}
                    //     <Divider style={{ margin: "5px 0px" }} />
                    //     <Button
                    //       icon={<PlusOutlined />}
                    //       type="link"
                    //       onClick={() => {
                    //         // setOpenCatModel(true);
                    //       }}
                    //     >
                    //       Add Category
                    //     </Button>
                    //   </>
                    // )}
                  />
                </Col>
              )}
              {/* <Col>
                  <Select                  
                    mode="multiple"
                    maxTagCount={"responsive"}
                    // value={"GST = " + (gstRate === 0 ? "All" : gstRate + "%")}
                    style={{ minWidth: "158px" }}
                    allowClear
                    value={gstRate}
                    onChange={(e: any) => {
                      setExportItemsData([]);
                      console.log(e);
                      setGstRate(e);
                      setPage(1);

                      // e === null ? setGstRate([]) :  (e);
                      // setGstRate(e === null ? null : e);
                      // console.log(gstRate);
                    }}
                    placeholder="GST"
                    options={companySettings?.gsts?.map((gst: any) => ({
                      value: gst?.id,
                      title: gst?.rate,
                      label: gst?.name,
                    }))}
                   
                  />
                </Col> */}

              <Col>
                {/* {location.pathname.split("/")[4] === "master" && ( */}
                <>
                  <Select
                    defaultValue={ItemType.All}
                    style={{ width: "140px" }}
                    onChange={(val: ItemType) => {
                      setExportItemsData([]);
                      // setType(1);
                      setType(val);
                    }}
                    options={[
                      { value: ItemType.All, label: "All Items" },
                      {
                        value: ItemType.OnlySalesItems,
                        label: "Only Sales Items",
                      },
                      {
                        value: ItemType.OnlyPurchaseItems,
                        label: "Only Purchase Items",
                      },
                    ]}
                  />
                </>
                {/* )} */}
              </Col>
              <Col>
                <Select
                  defaultValue={ItemStatus.Active}
                  style={{ width: "110px" }}
                  onSelect={(e) => {
                    setItemStatus(e);
                    setExportItemsData([]);
                    setPage(1);
                  }}
                  options={[
                    { value: ItemStatus.All, label: "All" },
                    { value: ItemStatus.Active, label: "Active" },
                    { value: ItemStatus.Inactive, label: "In-Active" },
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      )}

      {/* --------- Table --------- */}
      {props?.oldItem ? (
        <Table
          columns={columns}
          dataSource={
            loading
              ? (Array.from({ length: pageSize }, (_, index) => ({
                  key: `loading-${index}`,
                })) as IItemListData[])
              : itemsList
          }
          locale={{
            triggerDesc: "",
            triggerAsc: "",
            cancelSort: "",
          }}
          onChange={tableSort}
          className={`Tabel-style table-${
            themeData?.componentSize ?? "middle"
          }`}
          // rowSelection={rowSelection}
          pagination={{
            total: totalRecords,
            current: page,
            pageSize: pageSize,
            showSizeChanger: true,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
              setExportType(-1);
            },
            pageSizeOptions: tablePageSizeOptions,
            showTotal: (totalRecords, page) =>
              `${page[0]}-${page[1]} of ${totalRecords} items`,
          }}
          scroll={
            pageSize > 15
              ? { x: 1000, y: window.innerHeight - 320 }
              : { x: 1000 }
          }
        />
      ) : (
        <Table
          columns={columns}
          dataSource={
            loading
              ? (Array.from({ length: pageSize }, (_, index) => ({
                  key: `loading-${index}`,
                })) as IItemListData[])
              : itemsList
          }
          locale={{
            triggerDesc: "",
            triggerAsc: "",
            cancelSort: "",
          }}
          onChange={tableSort}
          className={`Tabel-style table-${
            themeData?.componentSize ?? "middle"
          }`}
          rowSelection={rowSelection}
          pagination={{
            total: totalRecords,
            current: page,
            pageSize: pageSize,
            showSizeChanger: true,
            onChange: (page: number, pageSize: number) => {
              setPage(page);
              setPageSize(pageSize);
              setExportType(-1);
            },
            pageSizeOptions: tablePageSizeOptions,
            showTotal: (totalRecords, page) =>
              `${page[0]}-${page[1]} of ${totalRecords} items`,
          }}
          scroll={
            pageSize > 15
              ? { x: 1000, y: window.innerHeight - 320 }
              : { x: 1000 }
          }
        />
      )}

      {/* --------- AddItem --------- */}
      {openModel.type === "addItem" && (
        <AddItems
          open={openModel?.param.open}
          onCancel={() => setOpenModel({ type: "", param: "" })}
          id={openModel?.param.id}
          // setTrigger={setTrigger((x) => !x)}
          setTrigger={setTrigger}
          oldItem={props?.oldItem}
        />
      )}
      {openModel.type === "deleteItem" && (
        <ConfirmationModal
          open={true}
          onNo={() => setOpenModel({ type: "", param: "" })}
          onYes={async () => {
            try {
              const deleteData = await ItemsServices.deleteItem(
                currentClient?.id!,
                openModel?.param?.id
              );
              if (deleteData.result) {
                openNotification(
                  "success",
                  `Item "${openModel?.param?.name}" deleted sucessfully.`
                );

                setTrigger((x) => !x);
                setOpenModel({ type: "", param: "" });
              } else {
                openNotification("error", deleteData?.message);
                console.log("error", deleteData?.message);
                setOpenModel({ type: "", param: "" });
              }
            } catch (err) {
              openNotification("error", err);
              console.log("error", err);
              setOpenModel({ type: "", param: "" });
            }
          }}
          text={`Are you sure you want to delete this "${openModel?.param?.name}" Item. ?`}
        />
      )}

      {/* Active / InActive ConfirmationModel */}
      {openModel.type === "isActive" && (
        <ConfirmationModal
          open={true}
          onNo={() => setOpenModel({ type: "", param: "" })}
          onYes={async () => {
            try {
              const apiData = await ItemsServices.isActiveItem(
                currentClient?.id!,
                openModel.param?.id,
                openModel.param?.itemStatus === ItemStatus.Inactive
                  ? ItemStatus.Active
                  : ItemStatus.Inactive
              );
              if (apiData.result) {
                openNotification(
                  "success",
                  `Item "${openModel?.param?.name}" ${
                    openModel?.param?.itemStatus === ItemStatus.Inactive
                      ? "Active"
                      : "InActive"
                  } sucessfully.`
                );

                setTrigger((x) => !x);
                setOpenModel({ type: "", param: "" });
              } else {
                openNotification("error", apiData?.message);
                console.log("error", apiData?.message);
                setOpenModel({ type: "", param: "" });
              }
            } catch (err) {
              openNotification("error", err);
              console.log("error", err);
              setOpenModel({ type: "", param: "" });
            }
          }}
          text={`Are you sure you want to ${
            openModel?.param?.itemStatus === ItemStatus.Inactive
              ? "Active"
              : "InActive"
          }  this "${openModel?.param?.name}" Item. ?`}
        />
      )}
      {/* </> */}
      {/* )} */}
    </Card>
  );
};

export default ItemTable;
